import { Stack, Typography } from '@mui/material';
import HomepPageList from '../../../../../Home/components/FourSolutions/components/HompageList';

const whatYouWillDo = [
  'Own the full sales cycle for Spona subscriptions – from outreach to close',
  'Develop strategic relationships with marketing, agency, and operations teams',
  'Customize outreach and demos for buyer personas across multiple industries',
  'Lead onboarding for new customers and ensure successful tool adoption',
  'Collaborate with the product & customer success teams to ensure client needs are met',
  'Hit acquisition targets and drive upsell/expansion opportunities',
  'Act as a feedback loop from the market to influence the product roadmap',
];

const youshouldHave = [
  '4+ years in B2B SaaS or tech sales (preferably in MarTech/Project tools)',
  'Experience owning customer onboarding or post-sales processes',
  'A hunter mindset paired with a strong sense of account ownership',
  'Strong communication skills and experience presenting to senior decision-makers',
  'Based in or near Dublin – this is an on-site position in our CoCreate office',
];

const SeniorCustomerGrowthSpecialist = () => (
  <Stack spacing={3}>
    <Typography variant="publicBody4">
      Location: Dublin (Sandyford, 6 Fern Road) | Type: Full-time | Industry: SaaS / Project
      Management / Media Tech
    </Typography>
    <Typography variant="publicBody4">
      We’re hiring a Senior Customer Growth Manager to drive the adoption and expansion of the Spona
      platform
    </Typography>
    <Typography variant="publicBody4Regular">
      You’ll be responsible for growing our customer base across Europe and supporting clients as
      they adopt our project and supplier management SaaS tool. This is a hands-on, cross-functional
      role spanning outbound sales, onboarding, and long-term client growth
    </Typography>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        What you will do:
      </Typography>
      <HomepPageList items={whatYouWillDo} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Stack>
      <Typography
        sx={{
          typography: { xs: 'publicBody5', sm: 'publicBody4' },
        }}
      >
        You should have:
      </Typography>
      <HomepPageList items={youshouldHave} sx={{ pl: { xs: '0.75rem', sm: '1.5rem' } }} />
    </Stack>

    <Typography variant="publicBody4">Please send your CV to: matija@spona.io</Typography>
  </Stack>
);

export default SeniorCustomerGrowthSpecialist;
